import { Outlet } from "react-router";
import Header from "./header/Header";
import SideBar from "./sidebar/SideBar";
import { getApi } from "../services/api/globalApi";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { handleUtils } from "../sotre/redux/features/utilsSlice";
import { PendingOrdersProvider } from "./header/PendingOrdersContext";
import { SidebarSettingsProvider } from "./sidebar/SidebarSettingsContext";
import { useAdminAccess } from "./access/AdminAccessContext";

export default function Layout() {
  const dispatch = useDispatch();
  const { canVisit } = useAdminAccess();
  const getUtils = async () => {
    const path = "api/utils/constants";
    try {
      const response = await getApi({ path });
      dispatch(handleUtils(response.data));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUtils();
  }, []);

  return (
    <PendingOrdersProvider enabled={canVisit("/order-list") || canVisit("/reports/order-statistics")}>
      <SidebarSettingsProvider>
        <div className="admin-app min-h-screen pb-10 bg-slate-50 dark:bg-slate-950">
          <Header />
          <div className="admin-shell w-11/12 mx-auto flex items-start gap-6 mt-6">
            <SideBar />
            <main className="admin-content min-w-0 flex-1">
              <Outlet />
            </main>
          </div>
        </div>
      </SidebarSettingsProvider>
    </PendingOrdersProvider>
  );
}
